import React from "react";
import { useWish } from "../../hooks/WishContext";
import { FaPlus, FaMinus, FaTrash, FaShoppingCart } from "react-icons/fa";
import { useCart } from "../../hooks/CartContext";

const WishList = () => {
  const { addToCart } = useCart();
  const { wish, removeFromWish, updateQuantity, clearWish } = useWish();

  const handleClearWish = () => {
    if (window.confirm("Are you sure you want to clear your wishlist?")) {
      clearWish();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 py-8 sm:py-10">
        {/* Header */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900">
            Your Wishlist
          </h1>

          {wish.length > 0 && (
            <button
              onClick={handleClearWish}
              className="inline-flex items-center justify-center gap-2 bg-red text-white px-4 py-2.5 rounded-xl font-semibold hover:opacity-90 transition w-full sm:w-auto"
            >
              Clear Wishlist <FaTrash />
            </button>
          )}
        </div>

        {/* Empty */}
        {wish.length === 0 ? (
          <div className="mt-16 sm:mt-20 bg-white rounded-2xl border border-gray-100 shadow-sm p-8 text-center">
            <p className="text-lg sm:text-xl font-semibold text-gray-900">
              Your wishlist is empty
            </p>
            <p className="text-gray-500 mt-1">
              Add products to save them for later
            </p>
          </div>
        ) : (
          <div className="mt-8 space-y-5">
            {wish.map((item) => {
              const soldOut = Number(item?.quantity || 0) < 1;
              const maxed = item.wishQuantity >= item.quantity;

              return (
                <div
                  key={item._id}
                  className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 sm:p-6"
                >
                  {/* Top row */}
                  <div className="grid grid-cols-1 sm:grid-cols-[96px_1fr_auto] gap-4 sm:gap-5 items-center">
                    {/* Image */}
                    <img
                      src={item.images?.[0] || "/placeholder.png"}
                      alt={item.name}
                      className="h-24 w-24 sm:h-24 sm:w-24 object-cover rounded-xl bg-gray-100"
                    />

                    {/* Details */}
                    <div className="min-w-0">
                      <h2 className="font-semibold text-gray-900 truncate">
                        {item.name}
                      </h2>
                      <p className="text-gray-600 font-bold mt-1">
                        ₦{Number(item.finalPrice || 0).toLocaleString()}
                      </p>
                      {/* <p className={`text-sm mt-1 font-semibold ${soldOut ? "text-gray-500" : "text-red"}`}>
                        {soldOut ? "Sold out" : `${item.quantity} unit(s) left`}
                      </p> */}
                    </div>

                    {/* Controls */}
                    <div className="flex items-center justify-between sm:justify-end gap-3">
                      <div className="inline-flex items-center gap-2 rounded-xl border border-gray-200 p-1">
                        <button
                          onClick={() =>
                            updateQuantity(item._id, Math.max(1, item.wishQuantity - 1))
                          }
                          className="h-10 w-10 grid place-items-center rounded-lg hover:bg-gray-50 transition"
                          aria-label="Decrease quantity"
                        >
                          <FaMinus />
                        </button>

                        <span className="w-10 text-center font-semibold text-gray-900">
                          {item.wishQuantity}
                        </span>

                        <button
                          onClick={() => {
                            if (!maxed) updateQuantity(item._id, item.wishQuantity + 1);
                          }}
                          disabled={maxed}
                          className="h-10 w-10 grid place-items-center rounded-lg hover:bg-gray-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
                          aria-label="Increase quantity"
                        >
                          <FaPlus />
                        </button>
                      </div>

                      <button
                        onClick={() => removeFromWish(item._id)}
                        className="h-10 w-10 grid place-items-center rounded-xl bg-red text-white hover:opacity-90 transition"
                        aria-label="Remove from wishlist"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-4">
                    <button
                      onClick={() => addToCart(item)}
                      disabled={soldOut}
                      className={`w-full py-3 rounded-xl flex items-center justify-center gap-2 font-semibold transition
                        ${
                          soldOut
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-red text-white hover:opacity-90"
                        }`}
                    >
                      <FaShoppingCart />
                      {soldOut ? "Sold Out" : "Add to Cart"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WishList;
